import React, {useContext} from 'react';

const HomeContext = React.createContext();

export const useHomeContext = () => useContext(HomeContext);

export default HomeContext;
